module.exports = __webpack_public_path__ + "static/media/refsocial.ecd29ee8.svg";